/**
 * A faixa da tela: 48 px, título à esquerda, comandos à direita.
 *
 * Uma faixa de comando por tela — regra 1 da padronização. Se uma tela quiser
 * uma segunda barra, a conversa é sobre a regra.
 */

import type { ReactNode } from "react"

export function Faixa({ titulo, codigo, detalhe, children }: {
  titulo: ReactNode
  /** Identificador. Monoespaçado, sempre — regra 8. */
  codigo?: string
  detalhe?: ReactNode
  children?: ReactNode
}) {
  return (
    <div
      className="barra"
      style={{
        height: 48, flex: "0 0 48px", display: "flex", alignItems: "center", gap: 12,
        padding: "0 18px", background: "var(--surface)", borderBottom: "1px solid var(--line)",
      }}
    >
      <div style={{ display: "flex", alignItems: "baseline", gap: 8, minWidth: 0 }}>
        {codigo && <span className="mono" style={{ fontSize: 15, fontWeight: 600, flex: "0 0 auto" }}>{codigo}</span>}
        <span style={{
          fontSize: 15, fontWeight: 600, letterSpacing: "-.005em",
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
        }}>
          {titulo}
        </span>
      </div>
      {/* `nowrap` porque sem ele "921 no total" quebra em três linhas empilhadas
          no celular, e a faixa fica mais alta que a lista. */}
      {detalhe && (
        <span style={{ fontSize: 12, color: "var(--txt2)", whiteSpace: "nowrap", flex: "0 0 auto" }}>
          {detalhe}
        </span>
      )}
      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>{children}</div>
    </div>
  )
}
